import { Component, forwardRef, inject, Input, Injector, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-form-textarea",
  templateUrl: "./form-textarea.component.html",
  styleUrls: ["./form-textarea.component.scss"],
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormTextareaComponent),
      multi: true,
    },
  ],
})
export class FormTextareaComponent implements ControlValueAccessor, OnInit {
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Input() disabled = false;
  @Input() value: string = "";
  @Input() required = false;

  private onChange = (_: any) => {};
  private onTouched = () => {};
  private injector = inject(Injector);
  private ngControl: NgControl | null = null;

  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl, null, {
      optional: true,
      self: true,
    });

    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  writeValue(obj: any): void {
    this.value = obj ?? "";
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event) {
    const value = (event.target as HTMLTextAreaElement).value;
    this.onChange(value);
  }

  onBlur() {
    this.onTouched();
  }

  get isRequired(): boolean {
    const validator = this.ngControl?.control?.validator;
    if (!validator) {
      return this.required;
    }

    const result = validator({} as any);
    return result?.required === true;
  }
}
